import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { DecideRefundRequest } from './interfaces';
import { falconClient } from '@/data/@clients';
import { baseUrl } from '@/data/subsidy/base';

export const useDecidedRefundRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: DecideRefundRequest) =>
      falconClient.patch(
        `${baseUrl}/refund_requests/${request.refund_request_uuid}/decide`,
        {
          decision_comment: request.decision_comment,
        }
      ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['refund-request', variables.refund_request_uuid],
      });
    },
  });
};
